import React, { FC, memo } from 'react';

import { DATA_TEST_IDS } from '../../consts';
import { TEXTS } from '../../texts';
import ReportSelectTrigger from '../../ReportSelectTrigger';
import type { AddressSelectTriggerProps } from './types';

const addressTriggerLabelledBy = [
  DATA_TEST_IDS.AUDIO_REPORT_ADDRESSES_LABEL,
  DATA_TEST_IDS.AUDIO_REPORT_ADDRESSES_TRIGGER_TITLE,
  DATA_TEST_IDS.AUDIO_REPORT_ADDRESSES_TRIGGER_COUNT,
].join(' ');

const AddressSelectTrigger: FC<AddressSelectTriggerProps> = ({
  dropdownId,
  isOpen,
  selectedCount,
  totalCount,
  onClick,
}) => (
  <ReportSelectTrigger
    ariaLabelledBy={addressTriggerLabelledBy}
    count={TEXTS.AUDIO_REPORT_ADDRESSES_SELECTED_COUNT_SHORT(selectedCount, totalCount)}
    countTestId={DATA_TEST_IDS.AUDIO_REPORT_ADDRESSES_TRIGGER_COUNT}
    dropdownId={dropdownId}
    elementId={DATA_TEST_IDS.AUDIO_REPORT_ADDRESSES_TRIGGER}
    iconTestId={DATA_TEST_IDS.AUDIO_REPORT_ADDRESSES_TRIGGER_ICON}
    isOpen={isOpen}
    testId={DATA_TEST_IDS.AUDIO_REPORT_ADDRESSES_TRIGGER}
    textTestId={DATA_TEST_IDS.AUDIO_REPORT_ADDRESSES_TRIGGER_TEXT}
    title={TEXTS.AUDIO_REPORT_ADDRESSES_SELECTED_TITLE}
    titleTestId={DATA_TEST_IDS.AUDIO_REPORT_ADDRESSES_TRIGGER_TITLE}
    onClick={onClick}
  />
);

export default memo(AddressSelectTrigger);
